import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import "./admin.css";

interface PodcastEpisode {
  id: string;
  title: string;
  description: string;
  date: string;
  youtube_url: string;
  image_url?: string;
}

export const AdminPodcastPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [episodes, setEpisodes] = useState<PodcastEpisode[]>([]);
  const [newEpisode, setNewEpisode] = useState<Partial<PodcastEpisode>>({});
  const [newImageFile, setNewImageFile] = useState<File | null>(null);
  const [isAdding, setIsAdding] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "podcast_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setEpisodes(data.episodes || []);
      }
    };
    fetchData();
  }, []);

  const handleHeaderUpload = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `podcast/header_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);

    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const uploadEpisodeImage = async (slug: string, file: File): Promise<string> => {
    const storageRef = ref(storage, `podcast/episodes/${slug}_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        undefined,
        reject,
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        }
      );
    });
  };

  const addEpisode = async () => {
    if (!newEpisode.title || !newEpisode.date || !newEpisode.description || !newEpisode.youtube_url) return;
  
    setIsAdding(true); // 👈 start loading
    try {
      const slug = newEpisode.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
  
      let imageUrl: string | undefined = undefined;
      if (newImageFile) {
        imageUrl = await uploadEpisodeImage(slug, newImageFile);
      }
  
      const newItem: PodcastEpisode = {
        id: slug + "-" + uuidv4().slice(0, 6),
        title: newEpisode.title,
        description: newEpisode.description,
        date: newEpisode.date,
        youtube_url: newEpisode.youtube_url,
        image_url: imageUrl,
      };
  
      setEpisodes((prev) => [...prev, newItem]);
      setNewEpisode({});
      setNewImageFile(null);
    } finally {
      setIsAdding(false); // 👈 stop loading
    }
  };
  

  const deleteEpisode = (id: string) => {
    setEpisodes((prev) => prev.filter((ep) => ep.id !== id));
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "podcast_page"), {
      header_image: headerImage,
      episodes,
    });
    alert("Episoadele au fost salvate!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Podcast</h1>

      <label>Imagine banner:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setHeaderFile(e.target.files?.[0] || null)}
      />
      <button onClick={handleHeaderUpload}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <h2>Episoade existente</h2>
      {episodes.map((ep) => (
        <div key={ep.id} className="episode-item">
          <strong>{ep.title}</strong>
          <p>{new Date(ep.date).toLocaleDateString("ro-RO")}</p>
          {ep.image_url && (
            <img src={ep.image_url} alt="Ep" className="episode-preview-img" />
          )}
          <button onClick={() => deleteEpisode(ep.id)}>Șterge</button>
        </div>
      ))}

      <hr />

      <h2>Adaugă episod nou</h2>
      <input
        type="text"
        placeholder="Titlu"
        value={newEpisode.title || ""}
        onChange={(e) => setNewEpisode({ ...newEpisode, title: e.target.value })}
      />
      <textarea
        placeholder="Descriere"
        value={newEpisode.description || ""}
        onChange={(e) => setNewEpisode({ ...newEpisode, description: e.target.value })}
      />
      <input
        type="date"
        value={newEpisode.date || ""}
        onChange={(e) => setNewEpisode({ ...newEpisode, date: e.target.value })}
      />
      <input
        type="text"
        placeholder="Link YouTube (ex: https://www.youtube.com/watch?v=...)"
        value={newEpisode.youtube_url || ""}
        onChange={(e) => setNewEpisode({ ...newEpisode, youtube_url: e.target.value })}
      />
      <label>Imagine episod:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setNewImageFile(e.target.files?.[0] || null)}
      />
     <button onClick={addEpisode} disabled={isAdding}>
  {isAdding ? "Se adaugă..." : "Adaugă"}
</button>
      <hr />
      <button className="save-btn" onClick={saveAll}>
        Salvează tot
      </button>
    </div>
  );
};
